<template>
  <div class="grid-container fluid pop-services mtxl">
    <div class="services-grid grid-container">
      <h2 class="header">
        {{ $t("services.popular-services") }}
      </h2>
      <hr>
      <div class="grid-x grid-margin-x">
        <div
          v-for="(service, index) in services"
          :key="index"
          class="cell large-6 medium-8 small-24 service-grid-item mvm"
        >
          <a
            class="service-container pal grid-x"
            :href="service.link"
          >
            <i
              :class="service.icon"
              class="cell small-4 medium-24"
            />
            <div class="service-title cell small-20 medium-24">{{ $t(service.key) }}</div>
          </a>
        </div>
      </div>
    </div>
    <div class="grid-container button-padding">
      <a
        class="button content-type-featured mbxl"
        href="#services"
        aria-label="Jump to all services"
      >
        <i class="fa-solid fa-arrow-down" />
        {{ $t("services.jump-to-all-services") }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      services: [
        {
          title: "Find your trash day",
          key: "services.trash",
          icon: "fa-solid fa-trash-can",
          link: "https://www.phila.gov/services/trash-recycling-city-upkeep/find-your-trash-and-recycling-collection-day/",
        },
        {
          title: "Pay a bill",
          key: "services.bill",
          icon: "fa-solid fa-file-invoice-dollar",
          link: "https://www.phila.gov/make-a-payment/",
        },
        {
          title: "Explore city jobs",
          key: "services.jobs",
          icon: "fa-solid fa-briefcase",
          link: "https://www.phila.gov/jobs/",
        },
        {
          title: "Search for a property",
          key: "services.property",
          icon: "fa-solid fa-building-magnifying-glass",
          link: "https://property.phila.gov/",
        },
        {
          title: "File and pay City taxes",
          key: "services.taxes",
          icon: "fa-solid fa-money-check-dollar",
          link: "https://www.phila.gov/services/payments-assistance-taxes/taxes/",
        },
        // {
        //   title: "Recycle fall leaves",
        //   key: "services.recycle",
        //   icon: "fa-solid fa-leaf",
        //   link: " https://www.phila.gov/services/trash-recycling-city-upkeep/recycle-fall-leaves/",
        // },
        {
          title: "Sign up for emergency alerts",
          key: "services.alerts",
          icon: "fa-solid fa-memo-circle-check",
          link: "https://www.phila.gov/services/safety-emergency-preparedness/sign-up-for-emergency-alerts/",
        },
        {
          title: "Visit an incarcerated person",
          key: "services.visit",
          icon: "fa-solid fa-building-user",
          link: "https://www.phila.gov/services/crime-law-justice/prisons-incarcerated-people-and-returning-citizens/finding-and-contacting-incarcerated-people/visit-an-incarcerated-person/",
        },
        {
          title: "Get a license",
          key: "services.license",
          icon: "fa-solid fa-file-certificate",
          link: "https://www.phila.gov/services/permits-violations-licenses/get-a-license/",
        },
      ],
    };
  },
  computed: {},
  mounted() { },
  methods: {},
};
</script>